module.exports = __webpack_public_path__ + "img/video-bg.323a2db3.png";